import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import DataTableConfig from "../Tables/DataTableConfig";
import useConfigApi from "../utils/configapi";
import Endpoints from "../utils/endpoints";
import toast from "react-hot-toast";

const DeletedDevices = () => {
  const api = useConfigApi();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchDeleted = async () => {
    try {
      setLoading(true);

      // HITS: /devices?deleted=true  ✅
      const resp = await api.get(Endpoints.devices.getAll(true));

      // Accept a few common shapes:
      // 1) { data: [...] }
      // 2) { data: { content: [...] } } (Spring Pageable)
      // 3) top-level array [...]
      const payload = resp?.data;
      const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.data?.content)
        ? payload.data.content
        : [];

      const mapped = list.map((d) => ({
        slNo: d?.slNo,
        terminalName: d?.terminalName ?? "-",
        serialNumber: d?.serialNumber ?? "-",
        terminalBrand: d?.terminalBrand ?? "-",

        groupConfigName: d?.groupConfig?.grpConfigName ?? "-",
        groupId: d?.groupConfig?.grpId ?? "-",
        grpType: d?.groupConfig?.grpType ?? "-", 

        terminalId: d?.terminalId ?? d?.controlConfig?.terminalId ?? "-",
        deletedDate: d?.deletedDate ? String(d.deletedDate).slice(0, 10) : "-",
      }));

      setRows(mapped);
    } catch (e) {
      console.error("Deleted devices fetch error:", e?.response ?? e);
      const msg =
        e?.response?.data?.responseMessage || e?.message || "Failed to load deleted devices.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleRestore = async (deviceSlNo) => {
    if (!deviceSlNo) {
      toast.error("Missing device ID.");
      return;
    }

    try {
      await api.put(Endpoints.devices.restore(deviceSlNo));
      toast.success("Device restored successfully.");
      fetchDeleted();
    } catch (e) {
      console.error("Restore error:", e?.response ?? e);
      const msg = e?.response?.data?.responseMessage || "Failed to restore device.";
      toast.error(msg);
    }
  };

  useEffect(() => {
    fetchDeleted();
  }, []);

  const RestoreButton = ({ row }) => (
    <MDButton
      variant="gradient"
      color="success"
      size="small"
      onClick={() => handleRestore(row.original.slNo)}
    >
      Restore
    </MDButton>
  );

  RestoreButton.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        slNo: PropTypes.number,
      }),
    }).isRequired,
  };

  const columns = [
    { Header: "Terminal Name", accessor: "terminalName", width: "14%" },
    { Header: "Serial Number", accessor: "serialNumber", width: "16%" },
    { Header: "Terminal Brand", accessor: "terminalBrand", width: "10%" },
    { Header: "Group Config Name", accessor: "groupConfigName", width: "14%" },
    { Header: "Group ID", accessor: "groupId", width: "12%" },
    { Header: "Group Type", accessor: "grpType", width: "8%"},
    // { Header: "Terminal Id", accessor: "terminalId", width: "10%" },
    { Header: "Deleted Date", accessor: "deletedDate", Cell: ({ value }) => (value ? String(value).slice(0, 10) : "-"), width: "10%" },
    {
      Header: "Action",
      accessor: "action",
      width: "10%",
      Cell: RestoreButton,
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <MDTypography variant="h6">Deleted Devices</MDTypography>
          <MDButton color="info" variant="outlined" onClick={fetchDeleted} disabled={loading}>
            Refresh
          </MDButton>
        </MDBox>
        <DataTableConfig
          table={{ columns, rows }}
          showTotalEntries
          isSorted
          noEndBorder
          entriesPerPage
          canSearch
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default DeletedDevices;
